import moment from "moment"
import { ConstantValuesItem } from "@/store/models/common"
import util from "./util"
import { EzAddress } from "@/asdcom/apiproxy/apiproxy.dto";
import AbpBase from "./abpbase"

export function L(value: string, source?: string, ...argus: string[]): string {
  return new AbpBase().L(value, source, ...argus)
}

export interface FormatAddressResult {
  line1?: string
  line2?: string
}

export default class AsdcomBase extends AbpBase {
  v_errors: any
  // L = L;

  loadCss(url:string, integrity?:string){
    console.log('load css:',url);
    var head = document.head;
    var link=document.createElement('link');
    link.rel="stylesheet"
    link.type="text/css";
    link.href=url;
    link.crossOrigin="anonymous";
    link.integrity=integrity||"";
    // document.body.appendChild(link);
    head.appendChild(link);
}


  plainTextToHtml(value: string): string {
    if (value == undefined) {
      return ""
    }
    // replace new lines with br tag.
    value = value.replace(/\n/g, "<br/>")
    return value
  }

  get userName(): string {
    const userName = this.$store.state.session.userName
    return userName
  }

  hasValue(val: any) {
    return val !== undefined && val !== null && (val + "").trim() !== ""
  }

  formatPhoneNumber(value: any) {
    // const newVal = (this.hasValue(value) && typeof value === 'string') ? value.replace(/(\d{3})(\d{3})(\d{4})/, "($1)$2-$3") : '-';
    return this.hasValue(value) && typeof value === "string"
      ? value
          .replace(/\D/g, "")
          .replace(/^0/, "")
          .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
      : undefined
  }

  getDateTime(date: any) {
    const ua = navigator.userAgent
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1
    if (this.hasValue(date) && !is_ie) {
      return `${new Date(date).toLocaleString(util.abp.localization.currentCulture.name, {
        timeZone: util.abp.timing.timeZoneInfo.iana.timeZoneId,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })}`
    } else if (this.hasValue(date) && is_ie) {
      return `${new Date(date).toLocaleString(util.abp.localization.currentCulture.name + "-US", {
        timeZone: util.abp.timing.timeZoneInfo.windows.timeZoneId,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })} [(CST)]`
    } else {
      return "-"
    }
  }

  getDate(date: any) {
    const ua = navigator.userAgent
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1
    if (this.hasValue(date) && !is_ie) {
      return new Date(date).toLocaleDateString(util.abp.localization.currentCulture.name, { timeZone: util.abp.timing.timeZoneInfo.iana.timeZoneId })
    } else if (this.hasValue(date) && is_ie) {
      return new Date(date).toLocaleDateString(util.abp.localization.currentCulture.name + "-US")
    } else {
      return "-"
    }
  }

  formatDate(date?: Date) {
    if (this.hasValue(date)) {
      return moment(date).format("l")
    }
    return undefined
  }

  formatDateTime(date?: Date) {
    if (this.hasValue(date)) {
      return moment(date).format("l LT")
    }
    return undefined
  }

  // getDateFromTo(dateFrom: any, dateTo: any, dateFormat: string = "MM/DD/YYYY") {
  // 	return `${this.getDate(dateFrom, dateFormat)} - ${this.getDate(dateTo, dateFormat)}`;
  // }

  formatAddress(adr: EzAddress): FormatAddressResult | undefined {
    let ln1: string | undefined = undefined
    let ln2: string | undefined = undefined

    if (this.hasValue(adr.addressLine1) && this.hasValue(adr.addressLine2)) {
      ln1 = `${adr.addressLine1}, ${adr.addressLine2}`
    } else if (this.hasValue(adr.addressLine1)) {
      ln1 = adr.addressLine1
    } else if (this.hasValue(adr.addressLine2)) {
      ln1 = adr.addressLine2
    }
    if (this.hasValue(adr.city)) {
      ln2 = adr.city
    }
    if (this.hasValue(adr.usStateCode)) {
      //const stateId = adr.state; //parseInt(adr.state);
      const stateName = this.getConstName("uSState", adr.usStateCode)
      if (ln2 !== undefined) {
        ln2 += `, ${stateName}`
      } else {
        ln2 = `${stateName}`
      }
    }
    if (this.hasValue(adr.postalCode)) {
      if (ln2 !== undefined) {
        ln2 += ` ${adr.postalCode}`
      } else {
        ln2 = `${adr.postalCode}`
      }
    }
    // let ret = ln1;
    // if (this.hasValue(ln1)) {
    // 	ret += ", " + ln2;
    // } else {
    // 	ret = ln2;
    // }
    const ret: FormatAddressResult = {
      line1: ln1,
      line2: ln2,
    }
    return ret
  }

  getDateFromTo(dateFrom: any, dateTo: any) {
    return `${this.getDate(dateFrom)} - ${this.getDate(dateTo)}`
  }

  convertConstValueToName(list: Array<any>, enumValue: number): string {
    let selectedItems = list.filter(val => {
      return val.value == enumValue
    })

    return selectedItems.length > 0 ? selectedItems[0].name : "-"
  }

  getConstName(constName: string, value?: number): string | undefined {
    // abp.log.debug({"getConstNam":{constName, value}});
    if (value != undefined) {
      constName = constName.toLowerCase()
      const object = util.abp.constant
      for (const key in object) {
        if (object.hasOwnProperty(key) && key.toLowerCase() == constName) {
          const list = object[key].values as ConstantValuesItem[]
          if (list) {
            const item = list.find(i => i.value == value)
            if (item) {
              return L(item.name)
            }
          }
        }
      }
    }
    return undefined
  }

  removeFromConstList(constObj: any, itemsToRemove: string[]) {
    const list: any[] = Object.assign([], constObj.values)

    for (let item in itemsToRemove) {
      const index = list.findIndex(i => {
        return i.name.toLowerCase() == itemsToRemove[item].toLowerCase()
      })
      list.splice(index, 1)
    }

    return list
  }

  removeSelf(constObj: any) {
    const list: any[] = Object.assign([], constObj.values)
    const selfIndex = list.findIndex(i => {
      return i.value == constObj.self
    })
    list.splice(selfIndex, 1)
    return list
  }

  getFullName(prefix?: string, first?: string, middle?: string, last?: string, suffix?: string): string | undefined {
    if (!!first || !!last) {
      return `${prefix || ""} ${first || ""} ${middle || ""} ${last || ""} ${suffix || ""}`
    } else {
      return undefined
    }
  }

  getFullNameOptions(name: { prefix?: string; first?: string; middle?: string; last?: string; suffix?: string }): string | undefined {
    if (!!name && (!!name.first || !!name.last)) {
      return `${name.prefix || ""} ${name.first || ""} ${name.middle || ""} ${name.last || ""} ${name.suffix || ""}`
    } else {
      return undefined
    }
  }

  isObjectEmpty(obj: any): boolean {
    const isEmpty = Object.values(obj).every(x => x === null || (x + "").trim() === "" || x === undefined)
    return isEmpty
  }

  boolToYesNo(val?: boolean) {
    if (!!val) {
      return L("Yes")
    } else {
      return L("No")
    }
  }

  newLineToHtml(val?: string) {
    if (!val) {
      return ""
    } else {
      return val.replace("\n", "<br/>")
    }
  }

  formatNumber(val?: number) {
    if (!!val) {
      return val.toLocaleString(util.abp.localization.currentCulture.name, { minimumFractionDigits: 2 })
    } else {
      return val
    }
  }
}
